import { Injectable } from '@angular/core';
import { API_METHODS, API_URL, OperationType, USER_TYPE } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';

import { FormDataService } from '../../base-data-services/form-data.service';
import { environment } from 'src/environments/environment';
import { TravelReimbursementGridPostParams, TravelReimbursementListingModel } from 'common/models/page-models/travel-reimbursement/travel-reimbursement-grid.model';
import { studentAssignmenListingtModel } from 'common/models/page-models/student-details/student-assignment-model';
import { StudentDetailsModel, studentDetails, } from 'common/models/page-models/student-details/student-details-model';
import { MentoringDocumentGridPostParams, MentoringDocumentListingModel } from 'common/models/page-models/mentoring-document/mentoring-document-grid.model';
import moment from 'moment';
import { TokenService } from 'common/services/core-services/get-token.service';
import { data } from 'jquery';
// import { log } from 'console';

@Injectable({
  providedIn: 'root',
})
export class StudentDetailsFormDataService extends FormDataService<StudentDetailsModel> {
  constructor(http: SmApiService, protected override ss: SystemService,
    private tokenService: TokenService
  ) {
    super(API_URL.editStudent, http, ss);
  }

  override getUpdatePayload(data) {
    // console.log(data);
    
    let payload;
    
    payload = {
      // pageNumber: 1,
      // pageSize: 10,
      id: data.id,
    };

    return payload;
  }
  getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.studentDetails,
      method: API_METHODS.post,
      id_key_name: 'id',
    };
    this.multiapiCallData();
    return edit;
  }
  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    return environment.apiUrl + this.getAPI_URL();
  }

  multiapiCallData() {
    this.setSystemServiceData('batch_number', API_URL.batchList, ' ', 'details');
    this.setSystemServiceData('zone_name', API_URL.zoneList, ' ', 'details');
    this.setSystemServiceData('state_List', API_URL.stateList, ' ', 'details');
    this.setSystemServiceData('package_list', API_URL.getPackageList, ' ', 'details');
    this.setSystemServiceData('branch_list', API_URL.branchList, ' ', 'details');
    this.setSystemServiceData('document_type', API_URL.getDocumentTypeList, '', 'details');
    // this.setSystemServiceData('district','','district',)
    // this.setSystemServiceData('details', API_URL.studentInternshipDetail, '', 'details')
  }

  formatDate(date: string): string {
    if (date && moment(date, moment.ISO_8601, true).isValid()) {
      return moment(date).format('DD/MM/YYYY');
    }
    return '';
  }

  formatDateTime(dateValue, p0: string) {
    if (!dateValue || dateValue === 0) {
      return '';
    }
    const formattedDate = moment(dateValue).format('DD/MM/YYYY hh:mm A');
    return moment(formattedDate, 'DD/MM/YYYY hh:mm A').isValid() ? formattedDate : '';
  }

  override modifyAPIResponse(response: any) {
    const dataModel = this.createInstance();
    dataModel.student_id = response.details.student_detail.id;
    dataModel.first_name = response.details.student_detail.first_name;
    dataModel.last_name = response.details.student_detail.last_name;
    dataModel.father_name = response.details.student_detail.father_name;
    dataModel.mother_name = response.details.student_detail.mother_name;
    dataModel.mobile_number = response.details.student_detail.mobile_number;
    console.log(response.details.student_detail.parentMobileNumber)
    dataModel.parentMobileNumber = response.details.student_detail.parentMobileNumber === 'null' ? null : response.details.student_detail.parentMobileNumber;
    dataModel.email = response.details.student_detail.email;
    dataModel.gender = this.uppercaseFirstLetter(response.details.student_detail.gender);
    dataModel.address = response.details.student_detail.address;
    dataModel.age = response.details.student_detail.age;
    // dataModel.region_id = this.uppercaseFirstLetter(response.details.student_detail.region);
    dataModel.region_id = response.details.student_detail.region_id;

    dataModel.state_id = response.details.student_detail.state_id;
    dataModel.district_id = response.details.student_detail.district_id;
    // console.log(response.details.student_detail.district);

    dataModel.name_of_college = response.details.student_detail.name_of_college;
    dataModel.college_address = response.details.student_detail.college_address;
    dataModel.unique_batch_id = response.details.student_detail.unique_batch_id;
    dataModel.branch_name = response.details.student_detail.branch_id;
    dataModel.batch_duration_start = response.details.student_detail.duration_start;
    dataModel.mentorId = response.details.student_detail.mentorId;
    dataModel.mentor_email = response.details.student_detail.mentor_email;
    dataModel.mentor_mobile = response.details.student_detail.mentor_mobile;
    dataModel.summer_vacation_start_date = this.formatDate(response.details.vacations.summer_vacation_start_date);
    dataModel.summer_vacation_end_date = this.formatDate(response.details.vacations.summer_vacation_end_date);
    dataModel.winter_vacation_start_date = this.formatDate(response.details.vacations.winter_vacation_start_date);
    dataModel.winter_vacation_end_date = this.formatDate(response.details.vacations.winter_vacation_end_date);
    dataModel.batch_number = response.details.student_detail.batch_number;
    dataModel.batch_id = response.details.student_detail.batch_id;
    dataModel.apiStudentDocumentDetailsList = response.details.studentDocumentDetails;
    dataModel.studentDetailsGridData = response.details.assignment_detail;
    dataModel.status = response.details.student_detail.status;
    dataModel.status_reason = response.details.student_detail.status_reason;
    dataModel.status_remark = response.details.student_detail.status_remarks;
    dataModel.profile_pic_path = response.details.student_detail.profile_pic_path;
    dataModel.assignment_detail = new studentAssignmenListingtModel();
    const modifiedAssignmentResponse = this.modifyResponse(response);
    dataModel.assignment_detail.originalModel = modifiedAssignmentResponse;
    dataModel.assignment_detail.filterModel = modifiedAssignmentResponse;
    dataModel.studentAchievementDetails = response.details.studentAchievementDetails;
    // console.log(dataModel.studentAchievementDetails);
    
    const numberOfPage = dataModel.assignment_detail.originalModel?.length > 0
      ? Math.ceil(dataModel.assignment_detail.originalModel.length / 10)
      : 0;

    dataModel.assignment_detail.pages = Array.from({ length: numberOfPage }, (_, idx) => ++idx);
    dataModel.assignment_detail.pageModel = this.getPageModel(1, dataModel.assignment_detail.originalModel, 10);
    // dataModel.travelReimbursementData = this.generateTravelReimbursementData(
    //   response.details.student_detail.student_id

    // );
    dataModel.mentoringDocumentData = this.generateMentoringDocumentData(response.details.student_detail.id);
    dataModel.first_year_score = response.details.student_detail.first_year_score;
    dataModel.first_year2_score = response.details.student_detail.first_year2_score;
    dataModel.second_year_score = response.details.student_detail.second_year_score;
    dataModel.second_year2_score = response.details.student_detail.second_year2_score;
    dataModel.third_year_score = response.details.student_detail.third_year_score;
    dataModel.third_year2_score = response.details.student_detail.third_year2_score;
    dataModel.fourth_year_score = response.details.student_detail.fourth_year_score;
    dataModel.fourth_year2_score = response.details.student_detail.fourth_year2_score;
    dataModel.batch_duration_start = response.details.student_detail.batch_duration_start;
    dataModel.first_year_credit = response.details.student_detail.first_year_credit;
    dataModel.second_year_credit = response.details.student_detail.second_year_credit;
    dataModel.third_year_credit = response.details.student_detail.third_year_credit;
    dataModel.fourth_year_credit = response.details.student_detail.fourth_year_credit;
    dataModel.placement_company_name = response.details.student_detail.placement_company_name;
    dataModel.placement_company_location = response.details.student_detail.placement_company_location;
    dataModel.placement_company_designation = response.details.student_detail.placement_company_designation;
    dataModel.placement_company_package = response.details.student_detail.placement_company_package;
    dataModel.placement_company_type = response.details.student_detail.placement_company_type;
    // console.log(response.details.student_detail.placement_company_type);
    dataModel.ktsem1 = response.details.student_detail.ktsem1;
    dataModel.ktsem2 = response.details.student_detail.ktsem2;
    dataModel.ktsem3 = response.details.student_detail.ktsem3;
    dataModel.ktsem4 = response.details.student_detail.ktsem4;
    dataModel.ktsem5 = response.details.student_detail.ktsem5;
    dataModel.ktsem6 = response.details.student_detail.ktsem6;
    dataModel.ktsem7 = response.details.student_detail.ktsem7;
    dataModel.ktsem8 = response.details.student_detail.ktsem8;
    dataModel.user_id = response.details.student_detail.user_id;
    dataModel.other = response.details.student_detail.other;

    // dataModel.district = response.district;


    // dataModel.details = new studentInternshipDataModel();

    // dataModel.details.isInvited = response.details.isInvited;
    // dataModel.details.studentExamStartDate = response.details.studentExamStartDate;
    // dataModel.details.studentExamEndDate = response.details.studentExamEndDate;
    // dataModel.details.studentSummerVacationStartDate = response.details.studentSummerVacationStartDate;
    // dataModel.details.studentSummerVacationEndDate = response.details.studentSummerVacationEndDate;
    // dataModel.details.studentExpectedInternshipStartDate = response.details.studentExpectedInternshipStartDate;
    // dataModel.details.studentExpectedInternshipEndDate = response.details.studentExpectedInternshipEndDate;
    // dataModel.details.studentAvailabilityRemark = response.details.studentAvailabilityRemark;
    // dataModel.details.isInternshipAssigned = response.details.isInternshipAssigned;
    // dataModel.details.isInternshipAssigned = response.details.isInternshipAssigned;
    // dataModel.details.internshipTitle = response.details.internshipTitle;
    // dataModel.details.internshipStartDate = response.details.internshipStartDate;
    // dataModel.details.internshipEndDate = response.details.internshipEndDate;

    return dataModel;
  }

  generateMentoringDocumentData(studentId) {
    const apiUrl = environment.apiUrl + API_URL.getStudentMentoringDocData;
    let payload = new MentoringDocumentGridPostParams();;
    payload['student_id'] = studentId;
    const mentoringDocumentModel = new MentoringDocumentListingModel();
    this.postDataToCustomEndPoint(payload, null, apiUrl).then((data) => {
      const modifiedResponse = this.modifyMentoringDocumentData(data)
      mentoringDocumentModel.originalModel = modifiedResponse;
      mentoringDocumentModel.filterModel = mentoringDocumentModel.originalModel;
      mentoringDocumentModel.pages = [2]
      mentoringDocumentModel.pageModel = modifiedResponse;
    })
    // console.log(mentoringDocumentModel.originalModel);

    return mentoringDocumentModel;
  }
  modifyMentoringDocumentData(response) {
    const data = response.details;
    // console.log(response, "data");

    data.forEach((key) => {
      key.year = key.year_number === 1 ? '1st Year' :
        key.year_number === 2 ? '2nd Year' :
          key.year_number === 3 ? '3rd Year' : '4th Year';

      key.mentorDocument = key.mentoringDoc;
      const userRole = JSON.parse(localStorage.getItem('profile'))?.role;
      // console.log(userRole, "userRole");
      key.isAdmin = userRole === USER_TYPE.admin;

      key.display_filename = key.display_filename || 'No File Name';
    });
    const sortedData = data.sort((a, b) => new Date(b.modified).getTime() - new Date(a.modified).getTime());

    return sortedData;
  }


  // override getDeleteUrl(): string {
  //   return environment.apiUrl + API_URL.DeletestudentMentoringDoc;
  // }

  // generateTravelReimbursementData(studentId) {
  //   const apiUrl = environment.apiUrl + API_URL.getTravelReimbursementData;
  //   let payload = new TravelReimbursementGridPostParams();
  //   payload['student_id'] = studentId;
  //   const travelReimbursementModel = new TravelReimbursementListingModel();
  //   this.postDataToCustomEndPoint(payload, null, apiUrl).then((data) => {
  //     const modifiedResponse = this.modifyTravelReimbirsementData(data);
  //     travelReimbursementModel.originalModel = modifiedResponse;
  //     travelReimbursementModel.filterModel =
  //       travelReimbursementModel.originalModel;
  //     travelReimbursementModel.pages = [1]; //Array.from({ length: numberOfPage }, (_, idx) => ++idx);
  //     travelReimbursementModel.pageModel = modifiedResponse;
  //   });
  //   return travelReimbursementModel;
  // }

  // modifyTravelReimbirsementData(response) {
  //   const data = response.detail;
  //   data.forEach((key) => {
  //     key.travelDocument = response.travelDocPath + key.travelDoc;
  //     const userRole = JSON.parse(localStorage.getItem('profile')).role;
  //     key.isAdmin = userRole === USER_TYPE.admin;
  //     key.approved = key.isApproved === '1' ? true : false;
  //   });
  //   return data;
  // }

  modifyResponse(response: any) {
    if (
        response.details.hasOwnProperty('assignment_detail') &&
        Array.isArray(response.details.assignment_detail)
    ) {
        response.details.assignment_detail.forEach((data) => {
            data.uploadFlag = data.upload_assignment_flag === 1 ? 'Yes' : 'No';

            data.uploadedFile = data.display_filename || '-';

            data.docPath = data.student_file_submit || '';

            data.start_date = this.formatDateTime(data.start_date, 'd/M/yyyy h:mm a') || data.start_date;
            data.end_date = this.formatDateTime(data.end_date, 'd/M/yyyy h:mm a') || data.end_date;

            data.student_id = response.details.student_detail?.student_id || null;
        });

        return response.details.assignment_detail;
    } else {
        return [];
    }
}


  getPageModel(currentPage, originalModel, recordPerPage) {
    const data = originalModel.slice(
      (currentPage - 1) * recordPerPage,
      recordPerPage * currentPage
    );
    return data;
  }

  createInstance(): StudentDetailsModel {
    return new StudentDetailsModel();
  }

  // override modifyAPIResponse(response: any) {
  //     return response['student_detail'];
  // }

  override getUpdateUrl() {
    return '';
  }

  uppercaseFirstLetter(str: string) {
    if (!str) return str;
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  }
  

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<StudentDetailsModel> {
    // console.log(model, "helllo")
    return new Promise<any>((resolve, reject) => {
      const submitData: any = new studentDetails();
      // console.log(model, '=======');

      submitData.first_name = model.first_name;
      submitData.last_name = model.last_name;
      submitData.father_name = model.father_name;
      submitData.mother_name = model.mother_name;
      submitData.mobile_number = model.mobile_number;
      submitData.parentMobileNumber = model.parentMobileNumber;
      submitData.email = model.email;
      submitData.address = model.address;
      submitData.gender = model.gender;
      submitData.age = model.age;
      submitData.date_of_birth = model.date_of_birth;
      submitData.college_address = model.college_address;
      submitData.branch_name = model.branch_id;
      submitData.state_id = model.state_id;
      submitData.first_year_score = model.first_year_score;
      submitData.second_year_score = model.second_year_score;
      submitData.third_year_score = model.third_year_score;
      submitData.fourth_year_score = model.fourth_year_score;
      submitData.first_year2_score = model.first_year2_score;
      submitData.second_year2_score = model.second_year2_score;
      submitData.third_year2_score = model.third_year2_score;
      submitData.fourth_year2_score = model.fourth_year2_score;
      submitData.ktsem1 = model.ktsem1;
      submitData.ktsem2 = model.ktsem2;
      submitData.ktsem3 = model.ktsem3;
      submitData.ktsem4 = model.ktsem4;
      submitData.ktsem5 = model.ktsem5;
      submitData.ktsem6 = model.ktsem6;
      submitData.ktsem7 = model.ktsem7;
      submitData.ktsem8 = model.ktsem8;
      submitData.first_year_credit = model.first_year_credit;
      submitData.second_year_credit = model.second_year_credit;
      submitData.third_year_credit = model.third_year_credit;
      submitData.fourth_year_credit = model.fourth_year_credit;
      submitData.id = model.user_id;
      submitData.placement_company_package = model.placement_company_package;
      submitData.placement_company_name = model.placement_company_name;
      submitData.placement_company_location = model.placement_company_location;
      submitData.placement_company_designation = model.placement_company_designation;
      submitData.parentMobileNumber = model.parentMobileNumber;
      submitData.region_id = model.region_id;
      submitData.name_of_college = model.name_of_college;
      submitData.unique_batch_id = model.unique_batch_id;
      submitData.batch_id = model.batch_id;
      submitData.status = model.status;
      submitData.status_reason = model.status_reason;
      submitData.status_remarks = model.status_remarks;
      submitData.district_id = model.district_id;
      submitData.branch_id = model.branch_name;
      submitData.mentorId = model.mentorId;
      submitData.mentor_email = model.mentor_email;
      submitData.mentor_mobile = model.mentor_mobile;
      submitData.other = model.other;
      if ((model.profile_pic_path instanceof File)) {
        submitData.profile_pic_path = model.profile_pic_path;
      };    
      resolve(this.convertFormData(submitData));

    });
  }



  postLoginData(data, url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      // const type = this.getOperationType(data);
      // const url = environment.apiUrl + API_URL.student_submit_details;

      this.apiService
        .postData(url, this.convertFormData(data))
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}

export { FormDataService };
